import { css, StyleSheet } from 'aphrodite';
import React, { ComponentProps } from 'react';
import { Avatar } from '@HoudiniUI/Avatar';
import { shuffleGray, titles, white } from '../../../../web/styles/colors';
import { shadowSm } from '../../../../web/styles/shadows';

export function CustomerAssistantContent({ styles = [], ...props }: AphroditeStyled<ComponentProps<'div'>>) {
	return <div className={css(s.content, ...styles)} {...props} />;
}

export function CustomerAssistantAvatar({ styles = [], ...props }: React.ComponentProps<typeof Avatar>) {
	return <Avatar styles={[s.avatar, ...styles]} {...props} />;
}

export function CustomerAssistantTitle({
	styles = [],
	...props
}: AphroditeStyled<React.HTMLAttributes<HTMLHeadingElement>>) {
	return <h2 className={css(s.title, ...styles)} {...props} />;
}

export function CustomerAssistantDescription({
	styles = [],
	...props
}: AphroditeStyled<React.HTMLAttributes<HTMLParagraphElement>>) {
	return <p className={css(s.description, ...styles)} {...props} />;
}

export function CustomerAssistantConversationStarters({
	styles = [],
	...props
}: AphroditeStyled<ComponentProps<'div'>>) {
	return <div className={css(s.conversationStarters, ...styles)} {...props} />;
}

export function CustomerAssistantConversationStarterCard({
	styles = [],
	...props
}: AphroditeStyled<ComponentProps<'button'>>) {
	return <button type='button' className={css(s.starterCard, ...styles)} {...props} />;
}

const s = StyleSheet.create({
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flex: 1,
		maxWidth: 768,
		width: '100%',
		margin: '0 auto',
		padding: 16,
		boxSizing: 'border-box',
	},
	avatar: {
		width: 84,
		height: 84,
	},
	title: {
		fontSize: 20,
		fontWeight: 'bold',
		textAlign: 'center',
		color: titles,
		margin: 0,
		padding: 0,
	},
	description: {
		fontSize: 16,
		color: titles,
		padding: 0,
		margin: 0,
		textAlign: 'justify',
	},
	conversationStarters: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit, minmax(248px, 1fr))',
		gap: 16,
		width: '100%',
	},
	starterCard: {
		fontSize: 14,
		boxSizing: 'border-box',
		padding: `16px 24px`,
		border: `1px solid ${shuffleGray}`,
		display: 'flex',
		justifyContent: 'center',
		gap: 8,
		borderRadius: 12,
		backgroundColor: white,
		boxShadow: shadowSm,
		cursor: 'pointer',
		userSelect: 'none',
		textAlign: 'center',
		':hover': {
			backgroundColor: '#18181b0d',
		},
	},
});
